import { filterClasses, NameHelper } from "@swivl-mono/helpers";
import { UserInterface } from "@swivl-mono/types";
import { Link } from "react-router-dom";
import { UsersOnlineManager } from "../../../../Models/Users/UsersOnline.Manager";

interface ConversationCardProps extends React.HTMLAttributes<HTMLDivElement> {
  user: UserInterface
  selectedUserId?: number | undefined;
  className?: string;
  isOnline?: boolean;
}

export const parseTime = (date: Date | undefined) => {
  if (!date) return "";
  const locale = navigator.language || 'en-US';
  return date.toLocaleString(locale, { hour: '2-digit', minute: '2-digit', hour12: true });
};

export function ClosedUserCard({ selectedUserId, user, className, isOnline = false, ...rest }: ConversationCardProps) {
  const name = NameHelper.nameForUser(user)
  const isSelected = user.id === selectedUserId;

  return (
    <Link
      className="text-black hover:text-black"
      to={`/conversations/user/${user.id}`}
    >
      <div className={
        filterClasses("flex w-full items-center gap-4 px-3 h-[58px] rounded-lg group transition-colors duration-100 ease-in-out hover:bg-grey-200",
          isSelected ? "bg-grey-100" : "bg-white",
          className
        )}
        {...rest}
      >
        {/* avatar */}
        <div className="flex items-center flex-1 min-w-0 space-x-3">
          <div className={filterClasses(
            "flex shrink-0 items-center justify-center rounded-full size-8 space-x-3 relative",
            "bg-grey-100 text-grey-700"
          )}>
            <span className="font-semibold text-lg">{name.charAt(0)}</span>

            {/* online indicator */}
            <div className={
              filterClasses(
                "size-2.5 rounded-full absolute bottom-0 -right-1.5 outline outline-[0.15rem] group-hover:outline-grey-200 transition-all duration-200",
                isSelected ? "outline-grey-100" : "outline-white",
                isOnline || UsersOnlineManager.isConversationFresh(user?.id) ? "bg-teal-450 border border-white" : "bg-white border border-grey-700"
              )}
            />
          </div>

          {/* customer name */}
          <span className="text-sm font-semibold truncate">{name}</span>
        </div>

        {/* time of last interaction */}
        <p className="text-grey-600 text-sm">{parseTime(user.lastInteractionAt)}</p>
      </div>
    </Link>
  )
}

